import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent11: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Chart competitive position</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Chart competitive position
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will show how well your product meets the Persona’s top two priorities, and how well the Persona’s priorities are met by existing products in comparison to your product. In this step you will also integrate your work from step 10 and iterate to make sure you have a logical core.

Specifically, you will also analyze whether the market opportunity you have chosen fits well with both your Core and your Persona’s priorities. The Competitive Position is where you take your Core and translate it into something that produces real value for the customer, something that they will care deeply about. The Competitive Positioning Chart shows visually how well your Persona’s top two priorities are filled by you versus how well your competition does so.

The goal is to show that your Competitive Position both leverages your Core and that your product satisfies your Persona’s priorities far better than existing or logical future products.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Creating the chart
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  Defining your Competitive Position is a quick way to validate your product against your competition, including the customer’s status quo, based on the top two priorities of the Persona. If you are not in the top right of the resulting chart, you should reevaluate your product offering, or at least the way you are presenting it. This will also be a very effective vehicle to communicate your qualitative (not quantitative) value proposition to the target customer audience in a way that should resonate with them.

Create a two-axis matrix chart.
On the x-axis, write the number one priority of your persona. On the half closer. On the half of the x-axis closer to the origin, write the “bad state” of this priority (e.g., if the priority is “reliability” then write “low” here). On the other half of the x-axis, write the “good” state of this priority (e.g., “high” for “reliability”).
On the y-axis, place the number-two priority of your Persona. Write the “bad state” on the half of the y-axis closer to the origin, and the “good state” on the other half of the y-axis.
Plot your business on the graph, along with those of your competitors (current and future). Also include the customer’s “do nothing” or “status quo” option.
If you’re positioned in any other position than top-right, reevaluate your product compared to your competition.
Review this chart with your target customers for feedback. Refine it as needed, until it accurately describes your product and the competition relative to the Persona’s top two priorities.
Review this chart to make sure that your Core supports your position in the top right corner.

                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent11 };
